import type { QuestionMatchingSchema } from '@repo/schemas/quiz/questionMatching';

import { standardSchemaResolver } from '@hookform/resolvers/standard-schema';
import { questionMatchingSchema } from '@repo/schemas/quiz/questionMatching';
import { useEffect } from 'react';
import { useFieldArray, useForm } from 'react-hook-form';
import { v4 as uuidv4 } from 'uuid';

export function useQuestionMatchingForm(data?: QuestionMatchingSchema) {
  const form = useForm<QuestionMatchingSchema>({
    defaultValues: data,
    mode: 'onChange',
    resolver: standardSchemaResolver(
      questionMatchingSchema.transform((data) => ({
        ...data,
        points: data.answers.reduce((sum, answer) => sum + (answer.points || 0), 0),
      }))
    ),
  });

  //trigger validation on component mount
  useEffect(() => {
    form.trigger();
  }, []);

  const matchingQuestionAnswers = useFieldArray<QuestionMatchingSchema>({
    control: form.control,
    name: 'answers',
  });

  const handleAddAnswer = (): void => {
    matchingQuestionAnswers.append({
      left: { id: uuidv4(), content: 'lewa strona' },
      right: { id: uuidv4(), content: 'prawa strona' },
      points: 1,
    });
  };

  const handleRemoveAnswer = (index: number): void => {
    matchingQuestionAnswers.remove(index);
  };

  return {
    form,
    matchingQuestionAnswers,
    handleAddAnswer,
    handleRemoveAnswer,
  };
}
